import type { RouteObject } from 'react-router-dom'

const attendanceRoute: RouteObject = {
  children: [
    { lazy: () => import('@/pages/attendance/shift-policy/index/page'), path: 'shift-policy' },
    { lazy: () => import('@/pages/attendance/shift-policy/create/page'), path: 'shift-policy/create' },
    { lazy: () => import('@/pages/attendance/shift-policy/edit/page'), path: 'shift-policy/:id/edit' },
    { lazy: () => import('@/pages/attendance/shift-management/index/page'), path: 'shift-management' },
    { lazy: () => import('@/pages/attendance/shift-management/schedule/page'), path: 'shift-management/schedule' },
    { lazy: () => import('@/pages/attendance/shift-management/create/page'), path: 'shift-management/create' },
    { lazy: () => import('@/pages/attendance/schedule/index/page'), path: 'schedule' },
    { lazy: () => import('@/pages/attendance/schedule/detail/page'), path: 'schedule/detail' },
    { lazy: () => import('@/pages/attendance/attendance-management/index/page'), path: 'attendance-management' },
    { lazy: () => import('@/pages/attendance/attendance-management/edit/page'), path: 'attendance-management/edit/:id' },
    {
      lazy: () => import('@/pages/attendance/attendance-management/create/page'),
      path: 'attendance-management/generate',
    },
    { lazy: () => import('@/pages/attendance/request-management/index/page'), path: 'request-management' },
    { lazy: () => import('@/pages/attendance/request-management/create/page'), path: 'request-management/create' },
    { lazy: () => import('@/pages/attendance/request-management/edit/page'), path: 'request-management/edit/:id' },
    { lazy: () => import('@/pages/attendance/correct-request-management/index/page'), path: 'correct-request-management' },
    { lazy: () => import('@/pages/attendance/correct-request-management/create/page'), path: 'correct-request-management/create' },
    { lazy: () => import('@/pages/attendance/correct-request-management/edit/page'), path: 'correct-request-management/edit/:id' },
    { lazy: () => import('@/pages/attendance/report/index/page'), path: 'report' },
    { lazy: () => import('@/pages/attendance/report/detail/page'), path: 'report/:employeeId' },
    { lazy: () => import('@/pages/attendance/shift-pattern/index/page'), path: 'shift-pattern' },
    { lazy: () => import('@/pages/attendance/shift-pattern/create/index/page'), path: 'shift-pattern/create' },
    { lazy: () => import('@/pages/attendance/shift-pattern/edit/index/page'), path: 'shift-pattern/edit/:id' },
    { lazy: () => import('@/pages/attendance/status/index/page'), path: 'status' },
  ],

  path: 'attendance',
}

export default attendanceRoute
